import "./styles.css";

export interface TextPopupDetails {
    title: string;
    message: string;
}

interface Props {
    onClose: () => void;
    details?: TextPopupDetails;
}

export default function TextPopup({ onClose, details }: Props) {
    return (
        <div className="text-popup">
            <div className="text-popup-header">
                <h3 className="text-popup-title">{details?.title}</h3>
                <button type="button" className="text-popup-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
            </div>
            <div className="text-popup-body">
                <p className="text-popup-message">{details?.message}</p>
            </div>
        </div>
    );
}
